export default __webpack_public_path__ + "static/water_w.c65918e70c3c7ed3c9a5b8b90509074a.svg";